import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { Employee, ServiceService } from './service.service';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AgentvalidationService } from '@app/services/agentvalidation.service';
// export interface Employee {
//   agentCode: string,
//   agentName: string,
//   status: string,
//   responseMessage: string,
//   isSuccessful: boolean,
// }
@Component({
  selector: 'app-agentvalid',
  templateUrl: './agentvalid.component.html',
  styleUrls: ['./agentvalid.component.scss'],
  
})
export class AgentvalidComponent implements OnInit {
    agentCode: string;
    agentName: string;
    status: string;
    responseMessage: string;
    isSuccessful: boolean;

  // constructor(private employeeService: ServiceService) { }

  ngOnInit() {
    
  }

  isVisible = false;


  showModal(): void {
    this.isVisible = true;
  }

  handleOk(): void {
    console.log('Button ok clicked!');
    this.isVisible = false;
  }

  handleCancel(): void {
    console.log('Button cancel clicked!');
    this.isVisible = false;
  }

  employeeForm: FormGroup;
  employeeInfo: { agentName: string; status: string } | null = null;
  error: string | null = null;

  constructor(
    private fb: FormBuilder,
    // private employeeService: ServiceService,
    public agentService: AgentvalidationService,
    
  ) {
    this.employeeForm = this.fb.group({
      code: ['', Validators.required],
    });
  }

  onSubmit() {
    this.employeeInfo = null;  // Clear previous result
    this.error = null;
    
    const codeControl = this.employeeForm.get('code');
    const code = codeControl ? codeControl.value : null;
    this.agentService.GetAgentValidation(code).subscribe(employee => {
      if (employee) {
        this.employeeInfo = {
          agentName: employee.agentName,
          // status: employee.status ? 'Active' : 'Inactive'
          status: employee.status, 
        };
      } else {
        this.employeeInfo = null;
      }

      //reset the form
      this.employeeForm.reset();
    },
    error => {
      this.error = 'Failed to fetch employee status. Please try again later.';
    }
  );
  }


  // openModal() {
  //   const modelDiv = document.getElementById('myModal');
  //   if(modelDiv != null) {
  //     modelDiv.style.display = 'block';
  //   }
  // }

  // closeModal() {
  //   const modelDiv = document.getElementById('myModal');
  //   if(modelDiv != null) {
  //     modelDiv.style.display = 'none';
  //   }
  // }


}
